/* eslint-disable @reatom/unit-naming-rule */
import { action, atom, readonly, withAssign } from '@reatom/framework'

import * as ExploreFilter from '../model/explore-filter'

import { reatomExploreFiltersPersistence } from './reatom-explore-filters-persistence'

export const reatomExploreFiltersState = (name: string) => {
  const persistence = reatomExploreFiltersPersistence(name)

  const filtersState = atom(persistence.filters, `${name}.filtersState`)

  const appliedFilterKeysAtom = atom(
    (ctx): Array<keyof ExploreFilter.ExploreFilter> => {
      const { keywords, providers, withMayhem, ...filters } =
        ctx.spy(filtersState)

      const appliedKeys = Object.entries(filters)
        .filter(([_, value]) => value !== undefined)
        .map(([key]) => key as keyof ExploreFilter.ExploreFilter)

      const providersApplied = providers !== 'all' || withMayhem

      return [
        ...appliedKeys,
        ...(keywords.length > 0 ? (['keywords'] as const) : []),
        ...(providersApplied ? (['providers'] as const) : []),
      ]
    },
    `${name}.appliedFilterKeysAtom`,
  )

  const appliedFiltersCountAtom = atom((ctx) => {
    const appliedFilterKeys = ctx.spy(appliedFilterKeysAtom)
    return appliedFilterKeys.length
  }, `${name}.appliedFiltersCountAtom`)

  const anyFilterAppliedAtom = atom((ctx) => {
    const filters = ctx.spy(appliedFiltersCountAtom)
    return filters > 0
  }, `${name}.anyFilterAppliedAtom`)

  const setAction = action((ctx, filters: ExploreFilter.ExploreFilter) => {
    filtersState(ctx, filters)
    persistence.save(filters)
  }, `${name}.setAction`)

  const resetAction = action((ctx) => {
    filtersState(ctx, ExploreFilter.EMPTY)
    persistence.clear()
  }, `${name}.resetAction`)

  return filtersState.pipe(
    readonly,
    withAssign(() => ({
      initialFilters: persistence.filters,
      set: setAction,
      reset: resetAction,
      appliedFiltersCount: appliedFiltersCountAtom,
      appliedFilterKeys: appliedFilterKeysAtom,
      anyFilterApplied: anyFilterAppliedAtom,
    })),
  )
}
export type ExploreFiltersStateModel = ReturnType<
  typeof reatomExploreFiltersState
>
